module.exports = __webpack_public_path__ + "img/knowledgeBase.98a0c903.svg";